module.exports = __webpack_public_path__ + "static/img/quirky-clock-light.7d51654d.svg";